module.exports = __webpack_public_path__ + "img/logo-pie.a07310a1.png";